import dayjs from 'dayjs'
import {
	formatDate,
	formatDateTime,
	timestampFields,
} from '../variable/constant'

export const generateRandomNumber = (min = 0, max = 0) => {
	return (
		Math.floor(Math.random() * ((max || 2000) - (min || 100) + 1)) +
		(min || 100)
	)
}
export const createRandomArray = (n: any) => {
	const randomArray = []
	for (let i = 0; i < n; i++) {
		const randomNumber = generateRandomNumber()
		randomArray.push(randomNumber)
	}
	return randomArray
}

export const convertOrder = (input: { [key: string]: 'asc' | 'desc' }[]): [string, 'asc' | 'desc'][] => {
	return input.map(orderObj => {
		const key = Object.keys(orderObj)[0];
		console.log(key);

		const value = orderObj[key];
		console.log(value);
		return [key, value];
	});
}

export const convertParams = (params: { [key: string]: any }) => {

	return Object.fromEntries(
		Object.entries(params).map(([key, value]) => {
			if (key === 'order') {
				return [key, convertOrder(value)]
			}
			return [key, JSON.stringify(value)]
		}),
	)
}
export const formatMoneyVND = (value?: string | number) => {
	const numberValue = Number(value)
	if (!Number.isFinite(numberValue)) return String(value || '-')

	return new Intl.NumberFormat('vi-VN', {
		style: 'currency',
		currency: 'VND',
		maximumFractionDigits: 0,
	}).format(numberValue)
}

export const formatMoney = (value?: string | number) => {
	const numberValue = Number(value)
	if (!Number.isFinite(numberValue)) return String(value || '-')

	return new Intl.NumberFormat('en-US', {
		style: 'currency',
		// currency: 'USD',
		maximumFractionDigits: 0,
	}).format(numberValue)
}

/**
 * Định dạng rút gọn:
 * - Kiểu 'approx': ~ 1 tỷ 158tr
 * - Kiểu 'detailed': 1 tỷ 158tr 490k
 */
export const formatVNDCompact = (value: number, type: 'approx' | 'detailed' = 'detailed'): string => {
  if (value === 0) return '0đ';

  const tỷ = Math.floor(value / 1_000_000_000);
  const triệu = Math.floor((value % 1_000_000_000) / 1_000_000);
  const nghìn = Math.floor((value % 1_000_000) / 1_000);

  if (type === 'approx') {
    let str = '';
    if (tỷ > 0) str += `${tỷ} tỷ `;
    if (triệu > 0) str += `${triệu}tr`;
    return `~ ${str.trim()}`;
  }

  // Kiểu detailed (chi tiết)
  let parts: string[] = [];
  if (tỷ > 0) parts.push(`${tỷ} tỷ`);
  if (triệu > 0) parts.push(`${triệu}tr`);
  if (nghìn > 0) parts.push(`${nghìn}K`);
  
  return parts.join(' ');
};

export const convertPhoneNumber = (phoneNumber) => {
	const prefixes = ['+84']
	const results = [] as any

	if (phoneNumber.startsWith('0')) {
		results.push(phoneNumber)
		prefixes.forEach((prefix) => {
			const convertedNumber = prefix + phoneNumber.slice(1)
			results.push(convertedNumber)
		})
	} else {
		results.push(phoneNumber)
	}

	return results
}
export const convertDate = (value: string, fields: string) => {
	if (value) {
		const format = timestampFields.includes(fields)
			? formatDate
			: formatDateTime
		const dateValue = isNaN(Number(value)) ? value : Number(value)
		return dayjs(dateValue).format(format)
	} else {
		return ''
	}
}

export const convertBoolean = (value: boolean) => {
	return value ? 'Yes' : 'No'
}
export const formatTimeNumber = (timestamp: number): string => {
	if (isNaN(timestamp) || timestamp === 0) {
		return '';
	}
	const date = new Date(timestamp);
	return dayjs(date).format(formatDateTime)
	// return date.toLocaleString(); // Adjust based on locale, e.g., 'en-US'
};
export const formatTime = (seconds: number) => {
	const hours = Math.floor(seconds / 3600)
	const minutes = Math.floor((seconds % 3600) / 60)
	const secs = seconds % 60

	const formattedTime = [
		hours > 0 ? `${hours}h` : '',
		minutes > 0 ? `${minutes}m` : '',
		secs > 0 ? `${secs}s` : '',
	]
		.filter(Boolean)
		.join('')

	return formattedTime || '0s' // Trả về "0s" nếu tất cả đều là 0
}

export const adjustToNearestMinutes = (
	sending_unix_timestamp,
	minutes: number,
) => {
	const currentMinute = dayjs(sending_unix_timestamp).minute()

	// Làm tròn lên đến bội số của 5
	const roundedMinute = Math.ceil(currentMinute / minutes) * minutes

	return dayjs(sending_unix_timestamp)
		.startOf('minute') // Đảm bảo chỉ lấy phần phút
		.minute(roundedMinute) // Cập nhật phút đã làm tròn
		.second(0) // Đặt giây về 0
		.valueOf() // Trả về timestamp
}

export const addMinutesAndRound = (date, minutesToAdd, minutesRound) => {
	// Thêm số phút vào thời gian hiện tại
	const newDate = dayjs(date).add(minutesToAdd, 'minutes')

	// Lấy phút hiện tại và làm tròn lên đến bội số của minutesRound
	const roundedMinutes =
		Math.ceil(newDate.minute() / minutesRound) * minutesRound

	// Đặt phút đã làm tròn, giây và mili giây về 0
	return newDate.minute(roundedMinutes).second(0).millisecond(0).toDate()
}

export const isUrl = (url: string) => {
	// eslint-disable-next-line no-useless-escape
	const urlRegex = /^(https?:\/\/)[\w.-]+\.[a-z]{2,}([\/?#][^\s]*)?$/i

	// Ví dụ sử dụng
	return urlRegex.test(url)
}


// Hàm chuyển đổi camelCase thành snake_case
function convertToSnakeCase(str: string): string {
	return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
}

export const convertFieldsToSnakeCase = (data: Record<string, any>) => {
	return Object.keys(data).reduce((acc, key) => {
		const newKey = convertToSnakeCase(key);
		acc[newKey] = data[key];
		return acc;
	}, {} as Record<string, any>);
};

// Hàm chuyển đổi snake_case thành camelCase
function convertToCamelCase(str: string): string {
	return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}
function toCamelCase(str: string): string {
	return str.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
}
export const convertFieldsToCamelCase = (data: Record<string, any>) => {
	return Object.keys(data).reduce((acc, key) => {
		const newKey = convertToCamelCase(key);
		acc[newKey] = data[key];
		return acc;
	}, {} as Record<string, any>);
};
export function convertDeepToCamelCase<T>(data: T): T {
	// Nếu là Array → map từng phần tử
	if (Array.isArray(data)) {
		return data.map(item => convertDeepToCamelCase(item)) as T;
	}

	// Nếu là Object (không phải null)
	if (data !== null && typeof data === 'object') {
		return Object.keys(data).reduce((acc, key) => {
			const camelKey = toCamelCase(key);

			acc[camelKey] = convertDeepToCamelCase(
				(data as Record<string, any>)[key]
			);

			return acc;
		}, {} as Record<string, any>) as T;
	}

	// Primitive (string, number, boolean, null, undefined)
	return data;
}
